export enum PublicationStatus {
	Unpublished = 'unpublished',
	Available = 'available',
	Unavailable = 'unAvailable',
	Running = 'running',
	Notifying = 'notifying',
	Waiting = 'waiting',
	Success = 'success',
	Error = 'error',
	Unknown = 'unknown',
}
